import { render, staticRenderFns } from "./cg-event-teaser-list.vue?vue&type=template&id=c2115326&scoped=true"
import script from "./cg-event-teaser-list.vue?vue&type=script&lang=js"
export * from "./cg-event-teaser-list.vue?vue&type=script&lang=js"
import style0 from "./cg-event-teaser-list.vue?vue&type=style&index=0&id=c2115326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2115326",
  null
  
)

export default component.exports